import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import FilterListIcon from '@mui/icons-material/FilterList';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import DownloadIcon from '@mui/icons-material/Download';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { blackdownload, downarrow, filtergrey, infogrey } from '../utils/safetysvgs/safetysvg';

const BbsData = () => {
  const data = [
    { name: '2 Hazard Recognition', low: 0, medium: 0, high: 90 },
    { name: '2 Congested Work Area', low: 0, medium: 0, high: 88 },
    { name: '2 Hand Protection', low: 0, medium: 0, high: 89 },
    { name: '6 Mobile Equipment', low: 0, medium: 0, high: 90 },
    { name: '1 Slips, Trips, Falls', low: 0, medium: 0, high: 91 },
    { name: '4 Pinch Points', low: 0, medium: 92, high: 0 },
    { name: 'Line of Fire', low: 0, medium: 92, high: 0 },
    { name: '3 Body Protection', low: 0, medium: 93, high: 0 },
    { name: '4 Excavations', low: 0, medium: 93, high: 0 },
    { name: '1 Eye & Face', low: 0, medium: 93, high: 0 },
  ];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-2 border border-gray-300 rounded shadow-sm text-sm">
          <p className="font-medium">{payload[0].payload.name}</p>
          {payload.map((entry, i) => (
            <p key={i} style={{ color: entry.color }}>
              {`${entry.name}: ${entry.value}%`}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="rounded-[12.75px] border border-[rgba(0,0,0,0.10)] bg-white p-4 w-full shadow-sm">
      {/* Header row */}
      <div className="flex justify-between items-center mb-4">
        {/* Left side */}
        <div className="flex items-center gap-2">
          <h2 className="text-base font-semibold text-[#0A0A0A]">BBS Compliance</h2>
    {infogrey}
        </div>

        {/* Right side buttons */}
        <div className="flex items-center gap-2">
          <button className="flex items-center gap-1 rounded-[6.75px] border border-[rgba(0,0,0,0.10)] bg-white px-3 py-1 text-sm text-black hover:bg-gray-100">
   {filtergrey}
            Filter
         {downarrow}
          </button>
          <button className="flex items-center gap-1 rounded-[6.75px] border border-[rgba(0,0,0,0.10)] bg-white px-3 py-1 text-sm text-black hover:bg-gray-100">
          
          {blackdownload}
            Export
          </button>
        </div>
      </div>

      {/* Chart */}
      <div className="mt-4 w-full h-[400px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            layout="vertical"
            data={data}
            margin={{ top: 10, right: 40, left: 20, bottom: 10 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis type="number" domain={[80, 100]} tickFormatter={(val) => `${val}%`} />
            <YAxis dataKey="name" type="category" width={200} />
            <Tooltip content={<CustomTooltip />} />
            <Legend />
            <Bar dataKey="low" stackId="a" fill="#2ECC71" name="Low Risk" />
            <Bar dataKey="medium" stackId="a" fill="#F39C12" name="Medium Risk" />
            <Bar dataKey="high" stackId="a" fill="#E74C3C" name="High Risk" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default BbsData;
